import React, { Fragment, useState, useContext } from "react";
import { signupReq } from "./fetchApi";
import { useSnackbar } from 'notistack';
import { LayoutContext } from "../index";
import GoogleAuth from './GoogleAuth';

const Signup = (props) => {
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    cPassword: "",
    error: false,
    loading: false,
    success: false,
  });
  const { dispatch: layoutDispatch } = useContext(LayoutContext);

  const alert = (msg, type) => (
    <div className={`text-sm ${type === 'red' ? 'text-red-600' : 'text-green-600'}`}>{msg}</div>
  );
  const { enqueueSnackbar } = useSnackbar();
  const formSubmit = async () => {
    setData({ ...data, loading: true });
    if (data.cPassword !== data.password) {
      return setData({
        ...data,
        error: {
          cPassword: "Le mot de passe ne correspond pas.",
          password: "Le mot de passe ne correspond pas.",
        },
      });
    }
    try {
      let responseData = await signupReq({
        name: data.name,
        email: data.email,
        password: data.password,
        cPassword: data.cPassword,
      });
      if (responseData.error) {
        setData({
          ...data,
          loading: false,
          error: responseData.error,
          password: "",
          cPassword: "",
        });
      } else if (responseData.success) {
        setData({
          success: responseData.success,
          name: "",
          email: "",
          password: "",
          cPassword: "",
          loading: false,
          error: false,
        })
        enqueueSnackbar('Inscription réussie !', { variant: 'success' })
        
        layoutDispatch({ type: "loginSignupModalToggle", payload: false });
        layoutDispatch({ type: "loginSignupModalToggle", payload: true });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Fragment>
      <form className="space-y-3 md:space-y-5 relative z-10">
        {data.success ? alert(data.success, "green") : ""}
        <div className="flex flex-col space-y-1 md:space-y-2">
          <label htmlFor="name" className="text-xs md:text-sm font-semibold text-gray-700">
            Nom complet<span className="text-red-500 ml-1">*</span>
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-2 md:pl-3 flex items-center pointer-events-none">
              <svg className="w-4 h-4 md:w-5 md:h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <input
              onChange={(e) =>
                setData({
                  ...data,
                  success: false,
                  error: {},
                  name: e.target.value,
                })
              }
              value={data.name}
              type="text"
              id="name"
              placeholder="Entrez votre nom"
              className={`${data.error.name ? "border-red-500 focus:border-red-500 focus:ring-red-500" : "border-gray-300 focus:border-blue-500 focus:ring-blue-500"} w-full pl-8 md:pl-10 pr-3 md:pr-4 py-2 md:py-3 border-2 rounded-lg md:rounded-xl focus:outline-none focus:ring-2 transition-all duration-200 bg-white text-sm md:text-base`}
            />
          </div>
          {!data.error ? "" : alert(data.error.name, "red")}
        </div>
        <div className="flex flex-col space-y-1 md:space-y-2">
          <label htmlFor="email" className="text-xs md:text-sm font-semibold text-gray-700">
            Adresse email<span className="text-red-500 ml-1">*</span>
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-2 md:pl-3 flex items-center pointer-events-none">
              <svg className="w-4 h-4 md:w-5 md:h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <input
              onChange={(e) =>
                setData({
                  ...data,
                  success: false,
                  error: {},
                  email: e.target.value,
                })
              }
              value={data.email}
              type="email"
              id="email"
              placeholder="exemple@email.com"
              className={`${data.error.email ? "border-red-500 focus:border-red-500 focus:ring-red-500" : "border-gray-300 focus:border-blue-500 focus:ring-blue-500"} w-full pl-8 md:pl-10 pr-3 md:pr-4 py-2 md:py-3 border-2 rounded-lg md:rounded-xl focus:outline-none focus:ring-2 transition-all duration-200 bg-white text-sm md:text-base`}
            />
          </div>
          {!data.error ? "" : alert(data.error.email, "red")}
        </div>
        
        {/* Mot de passe et confirmation sur la même ligne (mobile optimisé) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3">
          <div className="flex flex-col space-y-1 md:space-y-2">
            <label htmlFor="password" className="text-xs md:text-sm font-semibold text-gray-700">
              Mot de passe<span className="text-red-500 ml-1">*</span>
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-2 md:pl-3 flex items-center pointer-events-none">
                <svg className="w-4 h-4 md:w-5 md:h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <input
                onChange={(e) =>
                  setData({
                    ...data,
                    success: false,
                    error: {},
                    password: e.target.value,
                  })
                }
                value={data.password}
                type="password"
                id="password"
                placeholder="Min 6 car."
                className={`${data.error.password ? "border-red-500 focus:border-red-500 focus:ring-red-500" : "border-gray-300 focus:border-blue-500 focus:ring-blue-500"} w-full pl-8 md:pl-10 pr-2 md:pr-4 py-2 md:py-3 border-2 rounded-lg md:rounded-xl focus:outline-none focus:ring-2 transition-all duration-200 bg-white text-sm md:text-base`}
              />
            </div>
            {!data.error ? "" : alert(data.error.password, "red")}
          </div>
          
          <div className="flex flex-col space-y-1 md:space-y-2">
            <label htmlFor="cPassword" className="text-xs md:text-sm font-semibold text-gray-700">
              Confirmer<span className="text-red-500 ml-1">*</span>
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-2 md:pl-3 flex items-center pointer-events-none">
                <svg className="w-4 h-4 md:w-5 md:h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <input
                onChange={(e) =>
                  setData({
                    ...data,
                    success: false,
                    error: {},
                    cPassword: e.target.value,
                  })
                }
                value={data.cPassword}
                type="password"
                id="cPassword"
                placeholder="Confirmer"
                className={`${data.error.cPassword ? "border-red-500 focus:border-red-500 focus:ring-red-500" : "border-gray-300 focus:border-blue-500 focus:ring-blue-500"} w-full pl-8 md:pl-10 pr-2 md:pr-4 py-2 md:py-3 border-2 rounded-lg md:rounded-xl focus:outline-none focus:ring-2 transition-all duration-200 bg-white text-sm md:text-base`}
              />
            </div>
            {!data.error ? "" : alert(data.error.cPassword, "red")}
          </div>
        </div>
        <div className="flex items-start md:items-center">
          <input
            type="checkbox"
            id="rememberMe"
            className="w-4 h-4 mt-0.5 md:mt-0 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer flex-shrink-0"
          />
          <label htmlFor="rememberMe" className="ml-2 text-xs md:text-sm text-gray-700 cursor-pointer">
            J'accepte les conditions d'utilisation et la politique de confidentialité
          </label>
        </div>
        <div
          onClick={(e) => formSubmit()}
          className="w-full px-4 py-2.5 md:py-3.5 text-white bg-blue-600 hover:bg-blue-700 active:scale-95 transition-all duration-200 text-center cursor-pointer font-bold rounded-lg md:rounded-xl shadow-lg hover:shadow-xl text-sm md:text-base"
        >
          S'inscrire
        </div>

        {/* Divider */}
        <div className="flex items-center gap-2 md:gap-3 my-4 md:my-6">
          <div className="flex-1 h-px bg-gray-300"></div>
          <span className="text-xs text-gray-500 font-semibold uppercase tracking-wide">Ou continuer avec</span>
          <div className="flex-1 h-px bg-gray-300"></div>
        </div>

        {/* Google Sign Up */}
        <GoogleAuth isSignup={true} />
      </form>
    </Fragment>
  );
};

export default Signup;
